export const getProductName = (prodType: string) => {
  const treateProdType = (prodType ?? '').toLowerCase().trim();

  const prodMap = { vida: 'Vida Individual', odonto: 'Odonto Individual' };

  const prodName = prodMap[treateProdType];

  if (prodName) {
    return prodName;
  }

  return prodType;
};
